// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgErrorGeneric = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    data-name="Generic error"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="285 85 270 395"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.ge-1 {
  fill: #f198c0;
  stroke: #f198c0;
}

.ge-1,
.ge-2 {
  stroke-width: 2px;
}

.ge-1,
.ge-2,
.ge-3,
.ge-4,
.ge-5,
.ge-6 {
  stroke-miterlimit: 10;
}

.ge-7,
.ge-5 {
  fill: #fff;
}

.ge-2,
.ge-3,
.ge-4 {
  stroke: #000;
}

.ge-8 {
  fill: #f39ee5;
}

.ge-4,
.ge-5,
.ge-6 {
  stroke-width: 0.5px;
}

.ge-5 {
  stroke: #1d1e1c;
}

.ge-9 {
  fill: #474747;
}

.ge-10 {
  fill: #6f7476;
}

.ge-11 {
  fill: #ff49a4;
}

.ge-6 {
  stroke: #f5f5f5;
}
`}</style>
    </defs>
    <g>
      <path
        className="ge-3"
        d="M323.57,421.76c-13.84,4.99-31.01,6.13-32.07,7.58-2.27,3.1.75,17.83,6.7,25.67,5.95,7.84,23.03,2.39,35.53-1.89.94-.32,2.02-.72,3.17-1.14,1.19-.43,2.45-.88,3.78-1.38.76-.28,1.54-.6,2.37-.89.47-.16.93-.36,1.44-.53,1.83-.71,3.69-1.44,5.55-2.16,1.94-.74,3.83-1.51,5.62-2.22,3.47-1.38,6.57-2.62,8.82-3.53,1.71-.68,2.71-1.1,2.71-1.1-12.41-13.25-16.27-20.1-28.67-33.35"
      />
      <path
        className="ge-3"
        d="M507.36,421.76c13.84,4.99,31.01,6.13,32.07,7.58,2.27,3.1-.75,17.83-6.7,25.67-5.95,7.84-23.03,2.39-35.53-1.89-.94-.32-2.02-.72-3.17-1.14-1.19-.43-2.45-.88-3.78-1.38-.76-.28-1.54-.6-2.37-.89-.47-.16-.93-.36-1.44-.53-1.83-.71-3.69-1.44-5.55-2.16-1.94-.74-3.83-1.51-5.62-2.22-3.47-1.38-6.57-2.62-8.82-3.53-1.71-.68-2.71-1.1-2.71-1.1,12.41-13.25,16.27-20.1,28.67-33.35"
      />
    </g>
    <g>
      <path
        className="ge-4"
        d="M533.55,319.32c.89-2.86-10.28-16.84-18.02-26.3-7.74-9.43-16.05-19.82-24.44-27.93-3.44-3.34-8.44-7.89-13.11-12.06-1.02-.96-2.03-1.86-3-2.73-3.24-2.86-6.06-5.36-7.82-6.9-1.17-1.04-1.85-1.63-1.85-1.63,0,0-2.13,18.81-1.08,27.16.03.26.06.49.11.73,1.15,8.3,4.48,19.38,10.75,26.91,1.09,1.3,2.19,2.48,3.36,3.6.7.65,1.41,1.32,2.14,1.94.68.6,1.47,1.19,2.29,1.83,1.06.85,2.15,1.64,3.25,2.45.17.1.33.23.5.37.44.31.85.62,1.29.93,2.43,1.7,4.89,3.45,7.39,5.45.37.27.72.56,1.06.85.42.37.81.69,1.19,1.02,8.03,6.96,19.35,17.92,22.27,16.88,2.94-1.05,12.84-9.68,13.71-12.56Z"
      />
      <path
        className="ge-4"
        d="M299.26,319.32c-.89-2.86,10.28-16.84,18.02-26.3,7.74-9.43,16.05-19.82,24.44-27.93,3.44-3.34,8.44-7.89,13.11-12.06,1.02-.96,2.03-1.86,3-2.73,3.24-2.86,6.06-5.36,7.82-6.9,1.17-1.04,1.85-1.63,1.85-1.63,0,0,2.13,18.81,1.08,27.16-.03.26-.06.49-.11.73-1.15,8.3-4.48,19.38-10.75,26.91-1.09,1.3-2.19,2.48-3.36,3.6-.7.65-1.41,1.32-2.14,1.94-.68.6-1.47,1.19-2.29,1.83-1.06.85-2.15,1.64-3.25,2.45-.17.1-.33.23-.5.37-.44.31-.85.62-1.29.93-2.43,1.7-4.89,3.45-7.39,5.45-.37.27-.72.56-1.06.85-.42.37-.81.69-1.19,1.02-8.03,6.96-19.35,17.92-22.27,16.88-2.94-1.05-12.84-9.68-13.71-12.56Z"
      />
    </g>
    <path
      className="ge-7"
      d="M416.66,463.11c-47.94,0-99.49-56.7-86.78-122.8,2.81-14.59,6.3-28.79,10.59-42.07,14.8-46,38.99-80.73,76.19-80.73s62.11,32.97,76.62,78.89c4.33,13.67,7.69,28.47,10.16,43.91,10.63,66.63-38.85,122.8-86.78,122.8Z"
    />
    <path
      className="ge-2"
      d="M492.81,296.41c-13.62,27.85-42.93,47.11-76.87,47.11s-61.97-18.43-75.94-45.28c14.8-46,38.99-80.73,76.19-80.73s62.11,32.97,76.62,78.89Z"
    />
    <rect
      className="ge-11"
      x={445.66}
      y={238.73}
      width={20.48}
      height={37.09}
      rx={8.83}
      ry={8.83}
      transform="translate(-18.04 479.58) rotate(-54.57)"
    />
    <line className="ge-1" x1={446.43} y1={250.54} x2={467.4} y2={265.46} />
    <path
      className="ge-6"
      d="M472.22,229.52c.06-.02.11-.02.11-.02-7.33,23.09-23.06,38.14-28.04,54.69-6.64,22.04-8.65,44.72-10.53,46.77-3.78,4.06-26.4,4.06-31.41,0-2.52-2.05-1.75-23.56-9.27-43.14-8.54-22.19-9.76-25.5-20.74-42.52.02-.04.04-.11.11-.15-6.64-10.12-15.97-28.92-15.97-46.02,0-38.25,27.31-69.26,60.97-69.26s60.97,31.01,60.97,69.26c0,10.91-2.22,21.23-6.19,30.39Z"
    />
    <g>
      <path
        className="ge-5"
        d="M384.3,183.97c.18-11.47-9.01-20.91-20.52-21.09-11.51-.18-20.99,8.97-21.17,20.44-.18,11.47,9.01,20.91,20.52,21.09,11.51.18,20.99-8.97,21.17-20.44Z"
      />
      <path
        className="ge-5"
        d="M491.78,183.97c.18-11.47-9.01-20.91-20.52-21.09-11.51-.18-20.99,8.97-21.17,20.44-.18,11.47,9,20.91,20.51,21.09,11.51.18,20.99-8.97,21.17-20.44Z"
      />
    </g>
    <path d="M356.56,186.52c5.39,0,9.76-4.35,9.76-9.72s-4.37-9.72-9.76-9.72-9.76,4.35-9.76,9.72,4.37,9.72,9.76,9.72Z" />
    <path d="M477.39,200.82c5.39,0,9.75-4.35,9.75-9.72s-4.37-9.72-9.75-9.72-9.76,4.35-9.76,9.72,4.37,9.72,9.76,9.72Z" />
    <g>
      <path
        className="ge-8"
        d="M371.3,221.48c1.97-.81,3.29-1.62,4.08-3.57.79-1.96.4-3.45-.45-5.39-.85-1.94-2.95-3.74-4.76-4.51-1.8-.78-3.05-1.05-4.99-.7-1.93.35-4.94,2.26-5.67,4.24-.72,1.98-.4,3.45.45,5.39.85,1.94,2.37,3.56,4.76,4.51,2.38.95,4.61.84,6.57.03Z"
      />
      <path
        className="ge-8"
        d="M463.16,221.41c-1.98-.77-3.32-1.55-4.15-3.49-.83-1.94-.47-3.44.34-5.4.81-1.96,2.88-3.79,4.67-4.61,1.79-.81,3.03-1.11,4.97-.8,1.94.31,4.99,2.16,5.75,4.13.76,1.97.47,3.44-.34,5.4-.81,1.96-2.3,3.6-4.67,4.61-2.36,1-4.59.93-6.57.16Z"
      />
    </g>
    <g>
      <path
        className="ge-9"
        d="M382.83,142.53c-6.11,5.02-11.85,11.19-15.95,18.39-5.34-2.56-10.85-6.09-11.64-9.8-1.45-6.86,1.52-14.01,5.85-16.94,4.34-2.93,8.2-3.05,13.28-1.75,2.48.62,5.77,5.4,8.46,10.1Z"
      />
      <path
        className="ge-9"
        d="M479.66,151.12c-.79,3.72-7.06,7.24-12.4,9.8-4.1-7.2-8.84-12.07-14.95-17.08,2.69-4.7,5.74-10.79,8.22-11.41,5.08-1.3,8.95-1.17,13.28,1.75,4.34,2.93,7.3,10.08,5.85,16.94Z"
      />
    </g>
    <polygon
      className="ge-10"
      points="382.23 106.69 384.45 111.02 389.24 111.79 385.81 115.23 386.57 120.03 382.23 117.83 377.9 120.03 378.65 115.23 375.22 111.79 380.02 111.02 382.23 106.69"
    />
    <polygon
      className="ge-10"
      points="459.56 109.25 461.77 113.58 466.57 114.35 463.14 117.79 463.89 122.59 459.56 120.39 455.23 122.59 455.98 117.79 452.55 114.35 457.35 113.58 459.56 109.25"
    />
    <polygon
      className="ge-10"
      points="421.17 94.33 423.38 98.65 428.18 99.42 424.75 102.86 425.5 107.66 421.17 105.46 416.84 107.66 417.59 102.86 414.16 99.42 418.96 98.65 421.17 94.33"
    />
    <path
      className="ge-10"
      d="M391.48,118.26c18.35,4.96,37.49,2.77,56.07.53,1.58-.19,1.6-2.69,0-2.5-18.34,2.22-37.29,4.46-55.41-.44-1.56-.42-2.22,1.99-.66,2.41h0Z"
    />
    <path
      className="ge-10"
      d="M472.98,115.62c1.81-.48,3.3-1.85,3.86-3.66.59-1.92-.1-3.9-1.36-5.39-2.77-3.29-7.35-3.93-11.37-4.4-6.36-.74-12.72-1.47-19.1-1.99-3.27-.27-6.59-.55-9.87-.41-1.6.07-1.61,2.57,0,2.5,5.4-.24,10.9.45,16.27,1,2.91.29,5.82.61,8.72.95s5.62.5,8.34,1.18c1.93.49,3.99,1.32,5.25,2.94,1.37,1.77.92,4.26-1.4,4.87-1.55.41-.9,2.82.66,2.41h0Z"
    />
    <path
      className="ge-10"
      d="M371.73,109.86c-2-.51-2.81-2.55-1.66-4.26s3.1-2.52,4.94-3.03c3.23-.89,6.68-1.06,10.01-1.19,6.73-.27,13.51-.19,20.24.12,1.61.07,1.6-2.43,0-2.5-6.23-.29-12.49-.36-18.72-.18-2.92.08-5.82.26-8.71.66-3.38.47-7.11,1.38-9.39,4.14-1.17,1.42-1.81,3.28-1.24,5.09s2.06,3.1,3.86,3.55c1.56.39,2.23-2.02.66-2.41h0Z"
    />
  </svg>
);
export { SvgErrorGeneric };
